export enum NewProjectSuggestedRaise {
  Same = 'Same as current compensation range',
  Higher = 'Higher than current compensation range',
  NA = 'N/A',
}
